import React, { useRef } from "react";
import { getClassName } from "@sscs/utils";
import useScrollRestoration from "../../hooks/useScrollRestoration";
import { ErrorBoundary } from "../../index";
import styles from "./pageShell.module.scss";
const PageShell = ({ sidebar, contentClassName, children, }) => {
    const contentRef = useRef(null);
    useScrollRestoration(() => contentRef.current);
    return (React.createElement("div", { "data-page-shell": true, className: styles.shell },
        React.createElement("div", { className: styles.row },
            sidebar && React.createElement(ErrorBoundary, null, sidebar),
            React.createElement("section", { ref: contentRef, className: getClassName(styles.content, contentClassName), "data-scroll-container": true },
                React.createElement(ErrorBoundary, null, children)))));
};
export default PageShell;
//# sourceMappingURL=PageShell.js.map